import StatusButtons from 'components/StatusButtons'
import { Content, StatusContainer } from 'components/ChangeStatus/styles'
import { ChangeStatusProps } from 'components/ChangeStatus/types'
import { Label } from 'components/InputLabel/styles'

const ChangeStatus = ({
  setCurrentChangeStatus,
  currentChangeStatus,
}: ChangeStatusProps) => {
  const handleChangeActiveStatus = () => {
    setCurrentChangeStatus(1)
  }

  const handleChangeInactiveStatus = () => {
    setCurrentChangeStatus(2)
  }
  return (
    <StatusContainer>
      <Label>Status do usuário dentro do sistema</Label>
      <Content>
        <StatusButtons
          currentChangeStatus={currentChangeStatus}
          handleChangeActiveStatus={handleChangeActiveStatus}
          handleChangeInactiveStatus={handleChangeInactiveStatus}
        />
        {/** <LastAccess>Último acesso 25/01/2023 15:54 </LastAccess> */}
        
      </Content>
    </StatusContainer>
  )
}

export { ChangeStatus }
